import { Component } from '@theme/component';

/**
 * <mrk-countdown data-mrk-end="2026-10-20T23:59:59-05:00" data-mrk-hide=".mrk-promo">
 * Ticks DD : HH : MM : SS every second towards a real end date (rule I). When the date passes it hides
 * itself, or the closest ancestor matching data-mrk-hide.
 */
class MrkCountdown extends Component {
  end = Number.NaN;

  /** @type {number | undefined} */
  #timer;

  /** @type {Record<string, HTMLElement>} */
  #units = {};

  connectedCallback() {
    super.connectedCallback();
    this.end = Date.parse(this.dataset.mrkEnd ?? '');
    for (const unit of this.querySelectorAll('[data-mrk-unit]')) {
      if (unit instanceof HTMLElement && unit.dataset.mrkUnit) this.#units[unit.dataset.mrkUnit] = unit;
    }
    if (Number.isNaN(this.end)) {
      this.hidden = true;
      return;
    }
    this.#tick();
    this.#timer = window.setInterval(this.#tick, 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearInterval(this.#timer);
  }

  #tick = () => {
    const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    if (left === 0) {
      window.clearInterval(this.#timer);
      this.#expire();
      return;
    }
    const values = {
      d: Math.floor(left / 86400),
      h: Math.floor((left % 86400) / 3600),
      m: Math.floor((left % 3600) / 60),
      s: left % 60,
    };
    for (const [key, value] of Object.entries(values)) {
      const element = this.#units[key];
      const text = String(value).padStart(2, '0');
      if (element && element.textContent !== text) element.textContent = text;
    }
  };

  #expire() {
    const selector = this.dataset.mrkHide;
    const target = (selector && this.closest(selector)) || this;
    if (target instanceof HTMLElement) target.hidden = true;
  }
}

if (!customElements.get('mrk-countdown')) customElements.define('mrk-countdown', MrkCountdown);
